export var BoostOfferProductTag;
(function (BoostOfferProductTag) {
    BoostOfferProductTag.OfferStatusEnum = {
        Activated: 'Activated',
        NotActivated: 'NotActivated',
        Expired: 'Expired',
        Ended: 'Ended',
        Redeemed: 'Redeemed'
    };
})(BoostOfferProductTag || (BoostOfferProductTag = {}));
